export const en = {
  'classesAdmin.title': 'Classes',
  'classesAdmin.description': 'Group classes, their weekly schedule and defaults for generated sessions.',
  'classesAdmin.showInactive': 'Show inactive',
  'classesAdmin.generateSessions': 'Generate sessions',
  'classesAdmin.new': 'New class',
  'classesAdmin.empty': 'No classes yet',
  'classesAdmin.emptyHint': 'Create a class, add its weekly schedule, then generate sessions.',
  'classesAdmin.create': 'Create class',
  'classesAdmin.cardMeta': '{minutes} min · up to {capacity}',
  'classesAdmin.noDefaultTrainer': 'No default trainer',
  'classesAdmin.hiddenFromSite': 'Hidden from site',
  'classesAdmin.membersOnly': 'Members only',
  'classesAdmin.openToAll': 'Open to all',
  'classesAdmin.planCount': '{count} plan(s)',
  'classesAdmin.openSchedule': 'Schedule',
  'classesAdmin.deactivate': 'Deactivate',
  'classesAdmin.reactivate': 'Reactivate',
  'classesAdmin.deactivated': 'Class deactivated',
  'classesAdmin.reactivated': 'Class reactivated',
  'classesAdmin.deactivateTitle': 'Deactivate class?',
  'classesAdmin.deactivateDescription': '{name} and its weekly schedule will be switched off. Existing sessions stay as they are.',
  'classesAdmin.updated': 'Class updated',
  'classesAdmin.created': 'Class created',
  'classesAdmin.editTitle': 'Edit {name}',
  'classesAdmin.saveChanges': 'Save changes',
  'classesAdmin.field.colour': 'Colour',
  'classesAdmin.field.displayName': 'Display name',
  'classesAdmin.field.description': 'Description',
  'classesAdmin.field.defaultTrainer': 'Default trainer',
  'classesAdmin.field.noDefault': 'No default',
  'classesAdmin.field.location': 'Room',
  'classesAdmin.field.defaultRoom': 'Default room',
  'classesAdmin.field.defaultRoomHint': 'Used by slots and sessions at its branch that name no room',
  'classesAdmin.field.noDefaultRoom': 'No default room',
  'classesAdmin.field.capacity': 'Capacity',
  'classesAdmin.field.duration': 'Duration (minutes)',
  'classesAdmin.field.trainer': 'Trainer',
  'classesAdmin.field.requiresMembership': 'Requires an active membership',
  'classesAdmin.field.showOnWebsite': 'Show on the website',
  'classesAdmin.field.allowedPlans': 'Allowed plans',
  'classesAdmin.field.allowedPlansHint': 'Leave all unchecked to allow every plan that includes classes.',
  'classesAdmin.field.noClassPlans': 'No plans with class access yet.',
  'classesAdmin.minutes': '{minutes} min',
  'classesAdmin.schedule.added': 'Schedule added',
  'classesAdmin.schedule.slotExists': 'This class already has a slot on that day and time at this branch',
  'classesAdmin.schedule.removed': 'Schedule removed',
  'classesAdmin.schedule.title': 'Weekly schedule · {name}',
  'classesAdmin.schedule.description': 'Sessions are generated from these slots. Changes apply to future generation runs.',
  'classesAdmin.schedule.done': 'Done',
  'classesAdmin.schedule.empty': 'No weekly slots yet',
  'classesAdmin.schedule.emptyHint': 'Add the first slot below.',
  'classesAdmin.schedule.day': 'Day',
  'classesAdmin.schedule.time': 'Time',
  'classesAdmin.schedule.length': 'Length',
  'classesAdmin.schedule.valid': 'Valid',
  'classesAdmin.schedule.validRange': '{from} → {until}',
  'classesAdmin.schedule.validOnwards': '{from} onwards',
  'classesAdmin.schedule.removeSlot': 'Remove slot',
  'classesAdmin.schedule.addTitle': 'Add a weekly slot',
  'classesAdmin.schedule.weekday': 'Weekday',
  'classesAdmin.schedule.startTime': 'Start time',
  'classesAdmin.schedule.lengthMin': 'Length (min)',
  'classesAdmin.schedule.defaultValue': 'Default {value}',
  'classesAdmin.schedule.trainerClassDefault': 'Class default',
  'classesAdmin.schedule.roomClassDefault': 'Class default ({room})',
  'classesAdmin.schedule.noRoom': 'No room',
  'classesAdmin.schedule.validFrom': 'Valid from',
  'classesAdmin.schedule.validFromHint': 'Defaults to today',
  'classesAdmin.schedule.validUntil': 'Valid until',
  'classesAdmin.schedule.addSlot': 'Add slot',
  'classesAdmin.generate.created.one': '{count} session created',
  'classesAdmin.generate.created.other': '{count} sessions created',
  'classesAdmin.generate.description': 'Creates sessions for every active weekly slot in the date range. Existing sessions are kept.',
  'classesAdmin.generate.descriptionOwn': 'Creates sessions from your own weekly slots in the date range. Existing sessions are kept.',
  'classesAdmin.generate.submit': 'Generate',
  'sessions.title': 'Sessions',
  'sessions.description': 'The month’s timetable, week by week, one row per class time. Click a session to manage bookings and attendance.',
  'sessions.previousMonth': 'Previous month',
  'sessions.nextMonth': 'Next month',
  'sessions.today': 'Today',
  'sessions.new': 'New session',
  'sessions.weekOf': 'Week of {from} – {to}',
  'sessions.empty': 'No sessions this month',
  'sessions.emptyHint': 'Generate sessions from the weekly schedule or create one manually.',
  'sessions.goToClasses': 'Go to classes',
  'sessions.bookedOf': '{booked}/{capacity} booked',
  'sessions.waitlisted': '{count} waitlisted',
  'sessions.tab.bookings': 'Bookings',
  'sessions.tab.details': 'Details',
  'sessions.tab.book': 'Book a member',
  'sessions.bookingsUpdated.one': '{count} booking updated',
  'sessions.bookingsUpdated.other': '{count} bookings updated',
  'sessions.bookingCancelled': 'Booking cancelled',
  'sessions.noBookings': 'Nobody booked yet',
  'sessions.noBookingsHint': 'Use “Book a member” to add someone to this session.',
  'sessions.selectAll': 'Select all',
  'sessions.markAttended': 'Mark attended',
  'sessions.markNoShow': 'Mark no-show',
  'sessions.selected': '{count} selected',
  'sessions.member': 'Member',
  'sessions.selectMember': 'Select {name}',
  'sessions.cancelledLate': 'Cancelled late',
  'sessions.cancelBookingTitle': 'Cancel booking?',
  'sessions.cancelBookingDescription': '{name} will be removed from this session.',
  'sessions.cancelBooking': 'Cancel booking',
  'sessions.updated': 'Session updated',
  'sessions.cancelled': 'Session cancelled',
  'sessions.reinstated': 'Session reinstated',
  'sessions.reinstate': 'Reinstate session',
  'sessions.cancel': 'Cancel session',
  'sessions.saveChanges': 'Save changes',
  'sessions.cancelTitle': 'Cancel this session?',
  'sessions.cancelDescription': 'Members with bookings will be notified and their bookings cancelled.',
  'sessions.field.class': 'Class',
  'sessions.field.selectClass': 'Select a class',
  'sessions.field.starts': 'Starts',
  'sessions.field.length': 'Length (minutes)',
  'sessions.field.lengthHint': 'Defaults to the class length',
  'sessions.field.trainer': 'Trainer',
  'sessions.field.classDefault': 'Class default',
  'sessions.field.capacity': 'Capacity',
  'sessions.field.capacityHint': 'Defaults to the class capacity',
  'sessions.field.location': 'Room',
  'sessions.field.roomClassDefault': 'Class default',
  'sessions.field.noRoom': 'No room',
  'sessions.book.waitlisted': '{name} added to the waitlist',
  'sessions.book.booked': '{name} booked',
  'sessions.book.full': 'This session is full — new bookings go to the waitlist.',
  'sessions.book.spotsLeft.one': '{count} spot left.',
  'sessions.book.spotsLeft.other': '{count} spots left.',
  'sessions.book.addToWaitlist': 'Add to waitlist',
  'sessions.book.bookMember': 'Book member',
  'sessions.created': 'Session created',
  'sessions.newDescription': 'A one-off session outside the weekly schedule.',
  'sessions.create': 'Create session',
  'bookings.title': 'Bookings',
  'bookings.description': 'Who is booked into which session.',
  'bookings.anyStatus': 'Any status',
  'bookings.searchPlaceholder': 'Search by member, member number, class or trainer',
  'bookings.anyClass': 'Any class',
  'bookings.anyTrainer': 'Any trainer',
  'bookings.sessionsFrom': 'Sessions from',
  'bookings.sessionsTo': 'Sessions until',
  'bookings.upcomingOnly': 'Upcoming only',
  'bookings.empty': 'No bookings',
  'bookings.emptyUpcoming': 'Nothing is booked for upcoming sessions.',
  'bookings.emptyFiltered': 'No bookings match these filters.',
  'bookings.member': 'Member',
  'bookings.class': 'Class',
  'bookings.session': 'Session',
  'bookings.trainer': 'Trainer',
  'bookings.booked': 'Booked',
  'bookings.cancelled': 'Booking cancelled',
  'bookings.cancelTitle': 'Cancel booking?',
  'bookings.cancelConfirm': 'Cancel booking',
  'trainersAdmin.title': 'Trainers',
  'trainersAdmin.description': 'Coaches shown on the website and assigned to classes.',
  'trainersAdmin.speciality': 'Speciality',
  'trainersAdmin.allSpecialities': 'All specialities',
  'trainersAdmin.showInactive': 'Show inactive',
  'trainersAdmin.new': 'New trainer',
  'trainersAdmin.empty': 'No trainers yet',
  'trainersAdmin.emptyHint': 'Add your coaching team so they can be assigned to classes.',
  'trainersAdmin.add': 'Add trainer',
  'trainersAdmin.hiddenFromSite': 'Hidden from website',
  'trainersAdmin.onSite': 'On the website',
  'trainersAdmin.noneWithSpeciality': 'No trainer has this speciality',
  'trainersAdmin.view.grid': 'Grid',
  'trainersAdmin.view.list': 'List',
  'trainersAdmin.position': 'Position {position} on the website',
  'trainersAdmin.reorderHint': 'Drag a trainer by its handle to change the order on the website.',
  'trainersAdmin.reordered': 'Website order saved',
  'trainersAdmin.shown': '{name} is now on the website',
  'trainersAdmin.hidden': '{name} is now hidden from the website',
  'trainersAdmin.column.position': 'No.',
  'trainersAdmin.column.trainer': 'Trainer',
  'trainersAdmin.column.contact': 'Contact',
  'trainersAdmin.column.website': 'Website',
  'trainersAdmin.websiteProfile': 'Website profile',
  'trainersAdmin.profileTitle': 'Website profile: {name}',
  'trainersAdmin.profileDescription': 'How this trainer appears on the website. An empty field shows the roster name or the staff photo.',
  'trainersAdmin.profileSaved': 'Website profile saved',
  'trainersAdmin.newHint': 'A new trainer stays hidden from the website until marketing shows them.',
  'trainersAdmin.deactivate': 'Deactivate',
  'trainersAdmin.reactivate': 'Reactivate',
  'trainersAdmin.deactivated': 'Trainer deactivated',
  'trainersAdmin.reactivated': 'Trainer reactivated',
  'trainersAdmin.deactivateTitle': 'Deactivate trainer?',
  'trainersAdmin.deactivateDescription': '{name} will be hidden from the website and can no longer be assigned to sessions.',
  'trainersAdmin.updated': 'Trainer updated',
  'trainersAdmin.created': 'Trainer created',
  'trainersAdmin.editTitle': 'Edit {name}',
  'trainersAdmin.saveChanges': 'Save changes',
  'trainersAdmin.create': 'Create trainer',
  'trainersAdmin.field.photo': 'Staff photo',
  'trainersAdmin.field.photoHint': 'Square images look best. The website shows it until a website photo is set.',
  'trainersAdmin.field.sitePhoto': 'Website photo',
  'trainersAdmin.field.sitePhotoHint': 'Leave empty to show the staff photo.',
  'trainersAdmin.field.firstNameOnWebsite': 'First name on the website',
  'trainersAdmin.field.lastNameOnWebsite': 'Last name on the website',
  'trainersAdmin.field.bioOnWebsite': 'Bio on the website',
  'trainersAdmin.field.showOnWebsite': 'Show on website',
  'trainersAdmin.field.specialities': 'Specialities',
  'trainersAdmin.noSpecialities': 'No specialities yet. {link} first.',
  'trainersAdmin.addToList': 'Add them to the list',
  'trainersAdmin.off': '(off)',
  'trainersAdmin.missingOne': 'Missing one? {link}.',
  'trainersAdmin.manageList': 'Manage the list',
  'specialties.title': 'Specialities',
  'specialties.description': "The list trainers choose their specialities from. Names show on the website in the visitor's language.",
  'specialties.new': 'New speciality',
  'specialties.empty': 'No specialities yet',
  'specialties.emptyHint': 'Add the kinds of training your coaches offer, like Strength, Yoga or Boxing.',
  'specialties.add': 'Add speciality',
  'specialties.noGeorgianName': 'No Georgian name yet',
  'specialties.trainers.one': '{count} trainer',
  'specialties.trainers.other': '{count} trainers',
  'specialties.switchedOff': 'Switched off',
  'specialties.availableTo': '{name} available to trainers',
  'specialties.available': 'Available',
  'specialties.editName': 'Edit {name}',
  'specialties.deleteName': 'Delete {name}',
  'specialties.inUse': 'Trainers have this speciality; switch it off instead',
  'specialties.enabled': 'Speciality switched on',
  'specialties.disabled': 'Speciality switched off',
  'specialties.removed': 'Speciality removed',
  'specialties.deleteTitle': 'Delete speciality?',
  'specialties.deleteDescription': '{name} disappears from the list. No trainer has it.',
  'specialties.updated': 'Speciality updated',
  'specialties.added': 'Speciality added',
  'specialties.field.name': 'Name (English)',
  'specialties.field.nameHint': 'Names are unique regardless of case: Yoga and yoga are one speciality.',
  'specialties.field.nameOnWebsite': 'Name on the website',
  'specialties.field.order': 'Order',
  'specialties.field.orderHint': 'Lower comes first in pickers and on the website. Leave empty to put it last.',
};

export const ka: Record<keyof typeof en, string> = {
  'classesAdmin.title': 'ვარჯიშები',
  'classesAdmin.description': 'ჯგუფური ვარჯიშები, მათი კვირის განრიგი და გენერირებული სესიების ძირითადი პარამეტრები.',
  'classesAdmin.showInactive': 'არააქტიურების ჩვენება',
  'classesAdmin.generateSessions': 'სესიების გენერირება',
  'classesAdmin.new': 'ახალი ვარჯიში',
  'classesAdmin.empty': 'ვარჯიშები ჯერ არ არის',
  'classesAdmin.emptyHint': 'შექმენით ვარჯიში, დაამატეთ მისი კვირის განრიგი და შემდეგ დააგენერირეთ სესიები.',
  'classesAdmin.create': 'ვარჯიშის შექმნა',
  'classesAdmin.cardMeta': '{minutes} წთ · მაქსიმუმ {capacity} ადგილი',
  'classesAdmin.noDefaultTrainer': 'ძირითადი ტრენერი არ არის',
  'classesAdmin.hiddenFromSite': 'საიტზე დამალულია',
  'classesAdmin.membersOnly': 'მხოლოდ წევრებისთვის',
  'classesAdmin.openToAll': 'ღიაა ყველასთვის',
  'classesAdmin.planCount': '{count} პაკეტი',
  'classesAdmin.openSchedule': 'განრიგი',
  'classesAdmin.deactivate': 'დეაქტივაცია',
  'classesAdmin.reactivate': 'ხელახლა გააქტიურება',
  'classesAdmin.deactivated': 'ვარჯიში დეაქტივირებულია',
  'classesAdmin.reactivated': 'ვარჯიში ხელახლა გააქტიურდა',
  'classesAdmin.deactivateTitle': 'ვარჯიშის დეაქტივაცია?',
  'classesAdmin.deactivateDescription': 'ვარჯიში „{name}“ და მისი კვირის განრიგი გაითიშება. არსებული სესიები უცვლელი დარჩება.',
  'classesAdmin.updated': 'ვარჯიში განახლდა',
  'classesAdmin.created': 'ვარჯიში შეიქმნა',
  'classesAdmin.editTitle': 'რედაქტირება: {name}',
  'classesAdmin.saveChanges': 'ცვლილებების შენახვა',
  'classesAdmin.field.colour': 'ფერი',
  'classesAdmin.field.displayName': 'საჩვენებელი სახელი',
  'classesAdmin.field.description': 'აღწერა',
  'classesAdmin.field.defaultTrainer': 'ძირითადი ტრენერი',
  'classesAdmin.field.noDefault': 'ძირითადი ტრენერის გარეშე',
  'classesAdmin.field.location': 'ოთახი',
  'classesAdmin.field.defaultRoom': 'ნაგულისხმევი ოთახი',
  'classesAdmin.field.defaultRoomHint': 'გამოიყენება მისი ფილიალის სლოტებსა და სესიებზე, რომლებსაც ოთახი არ აქვთ არჩეული',
  'classesAdmin.field.noDefaultRoom': 'ნაგულისხმევი ოთახის გარეშე',
  'classesAdmin.field.capacity': 'ტევადობა',
  'classesAdmin.field.duration': 'ხანგრძლივობა (წუთი)',
  'classesAdmin.field.trainer': 'ტრენერი',
  'classesAdmin.field.requiresMembership': 'საჭიროებს აქტიურ აბონემენტს',
  'classesAdmin.field.showOnWebsite': 'ვებსაიტზე ჩვენება',
  'classesAdmin.field.allowedPlans': 'დაშვებული პაკეტები',
  'classesAdmin.field.allowedPlansHint': 'თუ არცერთს არ მონიშნავთ, დაშვებული იქნება ყველა პაკეტი, რომელიც ვარჯიშებს მოიცავს.',
  'classesAdmin.field.noClassPlans': 'ვარჯიშების შემცველი პაკეტი ჯერ არ არის.',
  'classesAdmin.minutes': '{minutes} წთ',
  'classesAdmin.schedule.added': 'განრიგი დაემატა',
  'classesAdmin.schedule.slotExists': 'ამ ვარჯიშს ამ ფილიალში ამ დღესა და დროს უკვე აქვს სლოტი',
  'classesAdmin.schedule.removed': 'განრიგი წაიშალა',
  'classesAdmin.schedule.title': 'კვირის განრიგი · {name}',
  'classesAdmin.schedule.description': 'სესიები ამ სლოტებიდან გენერირდება. ცვლილებები მომდევნო გენერირებებზე აისახება.',
  'classesAdmin.schedule.done': 'მზადაა',
  'classesAdmin.schedule.empty': 'კვირის სლოტები ჯერ არ არის',
  'classesAdmin.schedule.emptyHint': 'პირველი სლოტი ქვემოთ დაამატეთ.',
  'classesAdmin.schedule.day': 'დღე',
  'classesAdmin.schedule.time': 'დრო',
  'classesAdmin.schedule.length': 'ხანგრძლივობა',
  'classesAdmin.schedule.valid': 'მოქმედებს',
  'classesAdmin.schedule.validRange': '{from} → {until}',
  'classesAdmin.schedule.validOnwards': '{from}-დან',
  'classesAdmin.schedule.removeSlot': 'სლოტის წაშლა',
  'classesAdmin.schedule.addTitle': 'კვირის სლოტის დამატება',
  'classesAdmin.schedule.weekday': 'კვირის დღე',
  'classesAdmin.schedule.startTime': 'დაწყების დრო',
  'classesAdmin.schedule.lengthMin': 'ხანგრძლივობა (წთ)',
  'classesAdmin.schedule.defaultValue': 'ძირითადი: {value}',
  'classesAdmin.schedule.trainerClassDefault': 'ვარჯიშის ძირითადი ტრენერი',
  'classesAdmin.schedule.roomClassDefault': 'ვარჯიშის ნაგულისხმევი ({room})',
  'classesAdmin.schedule.noRoom': 'ოთახის გარეშე',
  'classesAdmin.schedule.validFrom': 'მოქმედების დასაწყისი',
  'classesAdmin.schedule.validFromHint': 'თუ ცარიელია, დღეიდან',
  'classesAdmin.schedule.validUntil': 'მოქმედების დასასრული',
  'classesAdmin.schedule.addSlot': 'სლოტის დამატება',
  'classesAdmin.generate.created.one': 'შეიქმნა {count} სესია',
  'classesAdmin.generate.created.other': 'შეიქმნა {count} სესია',
  'classesAdmin.generate.description': 'ქმნის სესიებს ყველა აქტიური კვირის სლოტისთვის არჩეულ პერიოდში. არსებული სესიები შენარჩუნდება.',
  'classesAdmin.generate.descriptionOwn': 'ქმნის სესიებს თქვენი კვირის სლოტებიდან მითითებულ პერიოდში. არსებული სესიები რჩება.',
  'classesAdmin.generate.submit': 'გენერირება',
  'sessions.title': 'სესიები',
  'sessions.description': 'თვის განრიგი კვირების მიხედვით, თითო რიგი ვარჯიშის თითო დროზე. დააჭირეთ სესიას ჯავშნებისა და დასწრების სამართავად.',
  'sessions.previousMonth': 'წინა თვე',
  'sessions.nextMonth': 'შემდეგი თვე',
  'sessions.today': 'დღეს',
  'sessions.new': 'ახალი სესია',
  'sessions.weekOf': 'კვირა: {from} – {to}',
  'sessions.empty': 'ამ თვეში სესიები არ არის',
  'sessions.emptyHint': 'დააგენერირეთ სესიები კვირის განრიგიდან ან შექმენით ხელით.',
  'sessions.goToClasses': 'ვარჯიშებზე გადასვლა',
  'sessions.bookedOf': 'დაჯავშნილია {booked}/{capacity}',
  'sessions.waitlisted': 'მოლოდინის სიაში: {count}',
  'sessions.tab.bookings': 'ჯავშნები',
  'sessions.tab.details': 'დეტალები',
  'sessions.tab.book': 'წევრის ჩაწერა',
  'sessions.bookingsUpdated.one': 'განახლდა {count} ჯავშანი',
  'sessions.bookingsUpdated.other': 'განახლდა {count} ჯავშანი',
  'sessions.bookingCancelled': 'ჯავშანი გაუქმდა',
  'sessions.noBookings': 'ჯერ არავინ ჩაწერილა',
  'sessions.noBookingsHint': 'ამ სესიაზე ვინმეს დასამატებლად გამოიყენეთ „წევრის ჩაწერა“.',
  'sessions.selectAll': 'ყველას მონიშვნა',
  'sessions.markAttended': 'დამსწრედ მონიშვნა',
  'sessions.markNoShow': 'გამოუცხადებლად მონიშვნა',
  'sessions.selected': 'მონიშნულია {count}',
  'sessions.member': 'წევრი',
  'sessions.selectMember': 'მონიშვნა: {name}',
  'sessions.cancelledLate': 'გვიან გაუქმდა',
  'sessions.cancelBookingTitle': 'ჯავშნის გაუქმება?',
  'sessions.cancelBookingDescription': '{name} ამ სესიიდან ამოიშლება.',
  'sessions.cancelBooking': 'ჯავშნის გაუქმება',
  'sessions.updated': 'სესია განახლდა',
  'sessions.cancelled': 'სესია გაუქმდა',
  'sessions.reinstated': 'სესია აღდგა',
  'sessions.reinstate': 'სესიის აღდგენა',
  'sessions.cancel': 'სესიის გაუქმება',
  'sessions.saveChanges': 'ცვლილებების შენახვა',
  'sessions.cancelTitle': 'გავაუქმოთ ეს სესია?',
  'sessions.cancelDescription': 'ჩაწერილ წევრებს შეტყობინება მიუვათ და მათი ჯავშნები გაუქმდება.',
  'sessions.field.class': 'ვარჯიში',
  'sessions.field.selectClass': 'აირჩიეთ ვარჯიში',
  'sessions.field.starts': 'დაწყება',
  'sessions.field.length': 'ხანგრძლივობა (წუთი)',
  'sessions.field.lengthHint': 'თუ ცარიელია, ვარჯიშის ხანგრძლივობა',
  'sessions.field.trainer': 'ტრენერი',
  'sessions.field.classDefault': 'ვარჯიშის ძირითადი ტრენერი',
  'sessions.field.capacity': 'ტევადობა',
  'sessions.field.capacityHint': 'თუ ცარიელია, ვარჯიშის ტევადობა',
  'sessions.field.location': 'ოთახი',
  'sessions.field.roomClassDefault': 'ვარჯიშის ნაგულისხმევი ოთახი',
  'sessions.field.noRoom': 'ოთახის გარეშე',
  'sessions.book.waitlisted': '{name} დაემატა მოლოდინის სიაში',
  'sessions.book.booked': '{name} ჩაიწერა',
  'sessions.book.full': 'სესია სავსეა — ახალი ჯავშნები მოლოდინის სიაში მოხვდება.',
  'sessions.book.spotsLeft.one': 'დარჩა {count} ადგილი.',
  'sessions.book.spotsLeft.other': 'დარჩა {count} ადგილი.',
  'sessions.book.addToWaitlist': 'მოლოდინის სიაში დამატება',
  'sessions.book.bookMember': 'წევრის ჩაწერა',
  'sessions.created': 'სესია შეიქმნა',
  'sessions.newDescription': 'ერთჯერადი სესია კვირის განრიგის გარეთ.',
  'sessions.create': 'სესიის შექმნა',
  'bookings.title': 'ჯავშნები',
  'bookings.description': 'ვინ რომელ სესიაზეა ჩაწერილი.',
  'bookings.anyStatus': 'ნებისმიერი სტატუსი',
  'bookings.searchPlaceholder': 'ძებნა წევრით, წევრის ნომრით, ვარჯიშით ან ტრენერით',
  'bookings.anyClass': 'ნებისმიერი ვარჯიში',
  'bookings.anyTrainer': 'ნებისმიერი ტრენერი',
  'bookings.sessionsFrom': 'სესიები თარიღიდან',
  'bookings.sessionsTo': 'სესიები თარიღამდე',
  'bookings.upcomingOnly': 'მხოლოდ მომავალი',
  'bookings.empty': 'ჯავშნები არ არის',
  'bookings.emptyUpcoming': 'მომავალ სესიებზე ჯერ არავინ ჩაწერილა.',
  'bookings.emptyFiltered': 'ამ ფილტრებით ჯავშანი ვერ მოიძებნა.',
  'bookings.member': 'წევრი',
  'bookings.class': 'ვარჯიში',
  'bookings.session': 'სესია',
  'bookings.trainer': 'ტრენერი',
  'bookings.booked': 'ჩაწერის დრო',
  'bookings.cancelled': 'ჯავშანი გაუქმდა',
  'bookings.cancelTitle': 'ჯავშნის გაუქმება?',
  'bookings.cancelConfirm': 'ჯავშნის გაუქმება',
  'trainersAdmin.title': 'ტრენერები',
  'trainersAdmin.description': 'ტრენერები, რომლებიც ვებსაიტზე ჩანან და ვარჯიშებზე ინიშნებიან.',
  'trainersAdmin.speciality': 'სპეციალობა',
  'trainersAdmin.allSpecialities': 'ყველა სპეციალობა',
  'trainersAdmin.showInactive': 'არააქტიურების ჩვენება',
  'trainersAdmin.new': 'ახალი ტრენერი',
  'trainersAdmin.empty': 'ტრენერები ჯერ არ არის',
  'trainersAdmin.emptyHint': 'დაამატეთ თქვენი ტრენერები, რომ ვარჯიშებზე დანიშვნა შეძლოთ.',
  'trainersAdmin.add': 'ტრენერის დამატება',
  'trainersAdmin.hiddenFromSite': 'ვებსაიტზე დამალულია',
  'trainersAdmin.onSite': 'ვებსაიტზე ჩანს',
  'trainersAdmin.noneWithSpeciality': 'ამ სპეციალობით ტრენერი არ არის',
  'trainersAdmin.view.grid': 'ბადე',
  'trainersAdmin.view.list': 'სია',
  'trainersAdmin.position': 'პოზიცია ვებსაიტზე: {position}',
  'trainersAdmin.reorderHint': 'ვებსაიტზე რიგის შესაცვლელად ტრენერი სახელურით გადაიტანეთ.',
  'trainersAdmin.reordered': 'ვებსაიტის რიგი შენახულია',
  'trainersAdmin.shown': '{name} ახლა ვებსაიტზე ჩანს',
  'trainersAdmin.hidden': '{name} ახლა ვებსაიტზე დამალულია',
  'trainersAdmin.column.position': '№',
  'trainersAdmin.column.trainer': 'ტრენერი',
  'trainersAdmin.column.contact': 'კონტაქტი',
  'trainersAdmin.column.website': 'ვებსაიტი',
  'trainersAdmin.websiteProfile': 'ვებსაიტის პროფილი',
  'trainersAdmin.profileTitle': 'ვებსაიტის პროფილი: {name}',
  'trainersAdmin.profileDescription': 'როგორ ჩანს ტრენერი ვებსაიტზე. თუ ველი ცარიელია, ჩანს ტრენერის ძირითადი სახელი ან თანამშრომლის ფოტო.',
  'trainersAdmin.profileSaved': 'ვებსაიტის პროფილი შენახულია',
  'trainersAdmin.newHint': 'ახალი ტრენერი ვებსაიტზე დამალულია, სანამ მარკეტინგი არ გამოაჩენს.',
  'trainersAdmin.deactivate': 'დეაქტივაცია',
  'trainersAdmin.reactivate': 'ხელახლა გააქტიურება',
  'trainersAdmin.deactivated': 'ტრენერი დეაქტივირებულია',
  'trainersAdmin.reactivated': 'ტრენერი ხელახლა გააქტიურდა',
  'trainersAdmin.deactivateTitle': 'ტრენერის დეაქტივაცია?',
  'trainersAdmin.deactivateDescription': '{name} ვებსაიტზე აღარ გამოჩნდება და სესიებზე ვეღარ დაინიშნება.',
  'trainersAdmin.updated': 'ტრენერი განახლდა',
  'trainersAdmin.created': 'ტრენერი შეიქმნა',
  'trainersAdmin.editTitle': 'რედაქტირება: {name}',
  'trainersAdmin.saveChanges': 'ცვლილებების შენახვა',
  'trainersAdmin.create': 'ტრენერის შექმნა',
  'trainersAdmin.field.photo': 'თანამშრომლის ფოტო',
  'trainersAdmin.field.photoHint': 'კვადრატული სურათები საუკეთესოდ გამოიყურება. ვებსაიტზე ის ჩანს, სანამ ვებსაიტის ფოტო არ დაემატება.',
  'trainersAdmin.field.sitePhoto': 'ფოტო ვებსაიტზე',
  'trainersAdmin.field.sitePhotoHint': 'ცარიელის შემთხვევაში ჩანს თანამშრომლის ფოტო.',
  'trainersAdmin.field.firstNameOnWebsite': 'სახელი ვებსაიტზე',
  'trainersAdmin.field.lastNameOnWebsite': 'გვარი ვებსაიტზე',
  'trainersAdmin.field.bioOnWebsite': 'ბიოგრაფია ვებსაიტზე',
  'trainersAdmin.field.showOnWebsite': 'ვებსაიტზე ჩვენება',
  'trainersAdmin.field.specialities': 'სპეციალობები',
  'trainersAdmin.noSpecialities': 'სპეციალობები ჯერ არ არის. ჯერ {link}.',
  'trainersAdmin.addToList': 'დაამატეთ ისინი სიაში',
  'trainersAdmin.off': '(გათიშული)',
  'trainersAdmin.missingOne': 'რომელიმე აკლია? {link}.',
  'trainersAdmin.manageList': 'სიის მართვა',
  'specialties.title': 'სპეციალობები',
  'specialties.description': 'სია, საიდანაც ტრენერები თავიანთ სპეციალობებს ირჩევენ. სახელები ვებსაიტზე ვიზიტორის ენაზე ჩანს.',
  'specialties.new': 'ახალი სპეციალობა',
  'specialties.empty': 'სპეციალობები ჯერ არ არის',
  'specialties.emptyHint': 'დაამატეთ ვარჯიშის სახეობები, რომლებსაც თქვენი ტრენერები სთავაზობენ, მაგალითად ძალოსნობა, იოგა ან კრივი.',
  'specialties.add': 'სპეციალობის დამატება',
  'specialties.noGeorgianName': 'ქართული სახელი ჯერ არ არის',
  'specialties.trainers.one': '{count} ტრენერი',
  'specialties.trainers.other': '{count} ტრენერი',
  'specialties.switchedOff': 'გათიშულია',
  'specialties.availableTo': '{name} ხელმისაწვდომია ტრენერებისთვის',
  'specialties.available': 'ხელმისაწვდომია',
  'specialties.editName': 'რედაქტირება: {name}',
  'specialties.deleteName': 'წაშლა: {name}',
  'specialties.inUse': 'ეს სპეციალობა ტრენერებს აქვთ; წაშლის ნაცვლად გათიშეთ',
  'specialties.enabled': 'სპეციალობა ჩაირთო',
  'specialties.disabled': 'სპეციალობა გაითიშა',
  'specialties.removed': 'სპეციალობა წაიშალა',
  'specialties.deleteTitle': 'სპეციალობის წაშლა?',
  'specialties.deleteDescription': '„{name}“ სიიდან გაქრება. ის არცერთ ტრენერს არ აქვს.',
  'specialties.updated': 'სპეციალობა განახლდა',
  'specialties.added': 'სპეციალობა დაემატა',
  'specialties.field.name': 'სახელი (ინგლისურად)',
  'specialties.field.nameHint': 'სახელები უნიკალურია რეგისტრის მიუხედავად: Yoga და yoga ერთი სპეციალობაა.',
  'specialties.field.nameOnWebsite': 'სახელი ვებსაიტზე',
  'specialties.field.order': 'რიგითობა',
  'specialties.field.orderHint': 'უფრო მცირე რიცხვი პირველია არჩევის სიებსა და ვებსაიტზე. დატოვეთ ცარიელი, რომ ბოლოში მოხვდეს.',
};
